module.exports = __webpack_public_path__ + "img/sprite.57213cdc.png";